'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Umoznuje vyvolat akci (dispatch action) nad centralnim redux store
                                                                                                                                                                                                                                                                   * pomoci data atributu data-dispatch-action. Volitelne je mozne predat jQuery selektory k inputum oddelene carkou,
                                                                                                                                                                                                                                                                   * ze kterych se vezme hodnota a ve stejnem poradi se predaji pozadovane akci jako parametry.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Supported elements:
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * a, button, input[type='button']  - action is dispatched on click event
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * div, span  -  action is dispatched on load
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Napr.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * <button data-dispatch-action="cart.sendOrder" data-dispatch-action-args="#OrderData,#Note,#ExtraInputData">Submit</button>
                                                                                                                                                                                                                                                                   */


exports.default = function () {
    (0, _jquery2.default)('[data-dispatch-action]:not(a,:button)', this).each(function () {
        dispatchActionForElement(this);
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _actions = require('../core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _index = require('../index');

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('debug')('linksoft:dispatch-action');

(0, _jquery2.default)(document).on('click', 'a[data-dispatch-action], :button[data-dispatch-action]', function () {
    dispatchActionForElement(this);
});
(0, _jquery2.default)(document).on('change', 'input[data-dispatch-action],select[data-dispatch-action]', function () {
    dispatchActionForElement(this);
});

function tryParse(str) {
    try {
        return JSON.parse(str);
    } catch (error) {
        return {};
    }
}

function dispatchActionForElement(el) {

    var $el = (0, _jquery2.default)(el);
    if ($el.is('.disabled')) return;
    var actionName = $el.attr('data-dispatch-action');
    var action = (0, _get3.default)(_actions2.default.get(), actionName);

    if (typeof action === 'function') {
        var args = $el.val() || $el.attr('data-dispatch-action-args') || '';

        var argsArray = [];
        if (args.trim().startsWith('{')) {
            // object stringify in data attribute
            argsArray.push(tryParse(args));
        } else {
            (0, _jquery2.default)(args).each(function () {
                // input selector(s)
                argsArray.push(tryParse((0, _jquery2.default)(this).val()));
            });
        }

        var actionArgs = {};
        argsArray.forEach(function (arg) {
            return (0, _assign2.default)(actionArgs, arg);
        });

        log('dispatching action: %s', actionName);

        onActionStart(el);
        (0, _index.dispatchAction)(action.call(_actions2.default, _extends({
            target: el,
            done: function done() {
                return onActionComplete(el);
            }
        }, actionArgs)));
    }
}

function onActionStart(el) {
    var $el = (0, _jquery2.default)(el);
    setLoadingIcon($el);
}

function onActionComplete(el) {
    var $el = (0, _jquery2.default)(el);
    setLoadingIcon($el, true);
}

function setLoadingIcon($el) {
    var restoreOriginal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if ($el.is(':button,a')) {
        $el.toggleClass('disabled', !restoreOriginal);
        var $icon = $el.find('.fa:first');
        if ($icon.length > 0) {
            if (restoreOriginal) {
                $icon.attr('class', $icon.data('orig-class')); // restore orig
            } else {
                $icon.data('orig-class', $icon.attr('class')); // backup orig
                var classes = $icon.attr('class').split(' ').filter(function (i) {
                    return !(0, _startsWith2.default)(i, 'fa-') || /^fa-\dx$/.test(i);
                });
                classes.push('fa-refresh', 'fa-spin');
                $icon.attr('class', classes.join(' '));
            }
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/dispatch-action.js
// module id = 583
// module chunks = 0 1